(function () {
  function initRoot(root) {
    if (!root || root.dataset.tmStoriesReady === '1') return;
    root.dataset.tmStoriesReady = '1';

    var sectionId = root.id.replace('tmStories-', '');
    var viewer = document.getElementById('tmStoryViewer-' + sectionId);
    if (!viewer) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tm-story-index]'));
    if (!items.length) return;

    var progress = viewer.querySelector('[data-tm-story-progress]');
    var img = viewer.querySelector('[data-tm-story-img]');
    var title = viewer.querySelector('[data-tm-story-title]');
    var excerpt = viewer.querySelector('[data-tm-story-excerpt]');
    var dateEl = viewer.querySelector('[data-tm-story-date]');
    var link = viewer.querySelector('[data-tm-story-link]');
    var duration = 5200;
    var index = 0;
    var timer = null;
    var seenKey = 'tmStoriesSeen:' + sectionId;

    function getSeen() {
      try {
        return JSON.parse(sessionStorage.getItem(seenKey) || '[]');
      } catch (e) {
        return [];
      }
    }

    function markSeen(i) {
      var seen = getSeen();
      var url = items[i] && items[i].getAttribute('data-tm-story-url');
      if (!url) return;
      if (seen.indexOf(url) === -1) seen.push(url);
      try {
        sessionStorage.setItem(seenKey, JSON.stringify(seen));
      } catch (e) {}
      items[i].classList.add('is-seen');
    }

    function paintSeen() {
      var seen = getSeen();
      items.forEach(function (el) {
        if (seen.indexOf(el.getAttribute('data-tm-story-url')) !== -1) {
          el.classList.add('is-seen');
        }
      });
    }

    function buildProgress() {
      progress.innerHTML = '';
      items.forEach(function () {
        var bar = document.createElement('div');
        bar.className = 'tm-story-viewer__bar';
        bar.innerHTML = '<i></i>';
        progress.appendChild(bar);
      });
    }

    function stopTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      var bars = progress.querySelectorAll('.tm-story-viewer__bar');
      bars.forEach(function (bar) {
        bar.classList.remove('is-active');
        var fill = bar.querySelector('i');
        if (fill) fill.style.animation = 'none';
      });
    }

    function show(i) {
      if (i < 0 || i >= items.length) {
        close();
        return;
      }
      index = i;
      var el = items[i];
      var src = el.getAttribute('data-tm-story-img') || '';
      img.style.opacity = '0';
      if (src) {
        img.hidden = false;
        img.onload = function () {
          img.style.opacity = '1';
        };
        img.src = src;
        if (img.complete) img.style.opacity = '1';
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
      title.textContent = el.getAttribute('data-tm-story-title') || '';
      excerpt.textContent = el.getAttribute('data-tm-story-excerpt') || '';
      dateEl.textContent = el.getAttribute('data-tm-story-date') || '';
      link.href = el.getAttribute('data-tm-story-url') || '#';

      var bars = progress.querySelectorAll('.tm-story-viewer__bar');
      bars.forEach(function (bar, bi) {
        bar.classList.toggle('is-done', bi < i);
        bar.classList.toggle('is-active', bi === i);
        var fill = bar.querySelector('i');
        if (!fill) return;
        fill.style.animation = 'none';
        // reflow for restart
        void fill.offsetWidth;
        if (bi === i) {
          fill.style.animation = '';
          fill.style.setProperty('--tm-story-duration', duration + 'ms');
        }
      });

      markSeen(i);
      stopTimer();
      timer = setTimeout(function () {
        show(i + 1);
      }, duration);

      // restart active bar animation properly
      var active = bars[i];
      if (active) {
        active.classList.remove('is-active');
        void active.offsetWidth;
        active.classList.add('is-active');
      }
    }

    function open(i) {
      buildProgress();
      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tm-story-open');
      show(i);
    }

    function close() {
      stopTimer();
      viewer.hidden = true;
      viewer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tm-story-open');
    }

    items.forEach(function (el) {
      el.addEventListener('click', function () {
        open(parseInt(el.getAttribute('data-tm-story-index'), 10) || 0);
      });
    });

    viewer.querySelectorAll('[data-tm-story-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    viewer.querySelector('[data-tm-story-prev]').addEventListener('click', function () {
      show(index - 1);
    });
    viewer.querySelector('[data-tm-story-next]').addEventListener('click', function () {
      show(index + 1);
    });

    document.addEventListener('keydown', function (evt) {
      if (viewer.hidden) return;
      if (evt.key === 'Escape') close();
      if (evt.key === 'ArrowLeft') show(index - 1);
      if (evt.key === 'ArrowRight') show(index + 1);
    });

    paintSeen();
  }

  function boot() {
    document.querySelectorAll('[data-tm-stories]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-tm-stories]');
    if (root) {
      root.dataset.tmStoriesReady = '';
      initRoot(root);
    }
  });
})();
